import { makeStyles } from '@fluentui/react-components';

export const useCSATByPurposeChartStyles = makeStyles({
  root: {
    width: '100%',
  },
});
